import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import layoutStyles from '../styles/layout.module.css';

const sectionStyle = { color: '#475569', lineHeight: 1.7 };

export default function Terms() {
  const navigate = useNavigate();
  const handleBack = useCallback(() => {
    if (window.history.length > 2) navigate(-1);
    else navigate('/home');
  }, [navigate]);

  return (
    <div className={layoutStyles.detailPage}>
      <TopBar variant="back" backLabel="Back" onBack={handleBack} rightActionLabel="Home" onRightAction={() => navigate('/home')} />
      <div style={{ maxWidth: 760, width: '100%', margin: '80px auto', padding: '0 16px 48px' }}>
        <h1>Terms &amp; Purchase Conditions</h1>
        <p style={sectionStyle}>
          Razzberry is a platform for music artists to publish digital collectibles for fans. By using Razzberry,
          you agree to these terms and purchase conditions.
        </p>

        <h2>Eligibility and Accounts</h2>
        <p style={sectionStyle}>
          You must be at least 18 years old to use the platform. You are responsible for your account credentials,
          the accuracy of the information you submit, and the activity that happens through your account.
        </p>

        <h2>Artist Access and Approval</h2>
        <p style={sectionStyle}>
          Artist tools are available only after Razzberry approves the account and the user activates an Artist Access
          subscription. Approval may be requested, delayed, denied, or revoked at our discretion. Subscription access
          may be paused or ended if billing stops or platform requirements are no longer met.
        </p>

        <h2>Payments and Purchase Conditions</h2>
        <p style={sectionStyle}>
          Payments are processed by Stripe. Prices, availability, launch timing, and inventory may change without
          notice before a transaction is completed. Digital collectible purchases may be final except where refunds or
          cancellations are required by law.
        </p>

        <h2>Buyer Responsibility</h2>
        <p style={sectionStyle}>
          Buyers are responsible for reviewing the artist, collectible details, price, and release information before
          completing a purchase. Razzberry does not guarantee the future value, resale opportunity, market demand, or
          continued availability of any collectible.
        </p>

        <h2>Artist Content and Rights</h2>
        <p style={sectionStyle}>
          Artists are responsible for the content they publish and for confirming they hold the rights needed to
          distribute it. Razzberry does not claim ownership of artist content and does not independently verify every
          right, license, or representation made by users.
        </p>

        <h2>Disclaimers and Liability</h2>
        <p style={sectionStyle}>
          Razzberry is provided on an "as is" and "as available" basis. We are not liable for artist conduct,
          user-submitted content, payment processor issues, third-party outages, pricing or release changes, missed
          purchase opportunities, indirect losses, or other damages arising from use of the platform except where law
          does not allow that limitation.
        </p>

        <h2>Company</h2>
        <p style={sectionStyle}>
          Razzberry is owned by iRobotX and is based in Calgary, Alberta, Canada.
        </p>
      </div>
    </div>
  );
}
